import { createAction, props } from '@ngrx/store';
import { CellularInterface } from '../cellular-interface.model';
import { DropDownColumns } from '@shared/models/shared.model';
import { Columns } from '@views/secure/devices/store/models/shared.model';

export const setCellularInterfaces = createAction(
  '[Cellular Interfaces] list',
  props<{ cellularInterfaces: CellularInterface[] }>()
);

export const updateCellularInterface = createAction(
  '[Cellular Interfaces] update',
  props<{ updatedCellularInterface: CellularInterface }>()
);

export const updateSelectedColumns = createAction(
  '[Cellular Interfaces] selected columns',
  props<{ selectedColumns: DropDownColumns[] }>()
);

export const updateUnselectedColumns = createAction(
  '[Cellular Interfaces] unselected columns',
  props<{ unselectedColumns: DropDownColumns[] }>()
);

export const updateReorderedColumns = createAction(
  '[Cellular Interfaces] reordered columns',
  props<{ reorderedColumns: Columns[] }>()
);

export const clearCellularInterface = createAction('[Cellular Interfaces] clear');

export const updateLastRefreshedAt = createAction(
  '[Cellular Interfaces] last refreshed at',
  props<{ lastRefreshedAt: string }>()
);
